export const CheckedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_4017_215)'>
        <rect width='24' height='24' rx='8' fill='#333840' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L11.2071 16.2071C10.8166 16.5976 10.1834 16.5976 9.79289 16.2071L5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929C5.68342 9.90237 6.31658 9.90237 6.70711 10.2929L10.5 14.0858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_4017_215'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UnCheckedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_4130_183)'>
        <rect x='0.5' y='0.5' width='23' height='23' rx='7.5' stroke='#B2B8C2' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L11.2071 16.2071C10.8166 16.5976 10.1834 16.5976 9.79289 16.2071L5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929C5.68342 9.90237 6.31658 9.90237 6.70711 10.2929L10.5 14.0858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z'
          fill='#B2B8C2'
        />
      </g>
      <defs>
        <clipPath id='clip0_4130_183'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
